import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'
import PapersList from './PapersList'
import { selectCitationsByPaperPageCount, selectVisibleReferencesByPaper, selectReferencesByPaperPageCount } from 'store/report/selectors'
import Paginator from 'components/misc/Paginator'
import CircleSpinner from 'components/misc/CircleSpinner'
import ProgressBar from 'components/misc/ProgressBar'
import Fade from 'components/misc/Fade'
import ReferencesList from './ReferencesList'
import CitationsHeader from './CitationsHeader'
import { useRef } from 'react'
import styles from './styles/Citations.css'

export function Citations ({ loading }) {
  const ref = useRef()
  const { search } = useLocation()
  const query = qs.parse(search)

  const showReferences = useSelector(({ report }) => report.filters.showReferences)
  const citationsLoadProgress = useSelector(({ report }) => report.citationsLoadTracker?.progress)
  const referencesByPaper = useSelector(({ report }) => selectVisibleReferencesByPaper(report))
  const currentPublicationDOI = useSelector(({ report }) => report.paper)
  const metadata = useSelector(({ report }) => report.metadata)
  const textMatch = useSelector(({ report }) => report.filters.textMatch)

  const citationProgress = citationsLoadProgress?.citations || 0
  const referenceProgress = citationsLoadProgress?.references || 0

  const pageCount = useSelector(({ report }) => showReferences ? selectReferencesByPaperPageCount(report) : selectCitationsByPaperPageCount(report))
  const currentPage = useSelector(({ report }) => report.filters.currentPage)

  if (loading) {
    return (
      <div className={styles.loadingLayout}>
        <CircleSpinner />
        <Fade className={styles.progressWrapper} show={!!citationsLoadProgress}>
          <ProgressBar progress={Math.round((citationProgress + referenceProgress) / 2)} />
        </Fade>
      </div>
    )
  }

  return (
    <div className={styles.citations} ref={ref}>
      <CitationsHeader />
      {
        showReferences
          ? <ReferencesList textMatch={textMatch} sourceDOI={currentPublicationDOI} papers={referencesByPaper} />
          : <PapersList paywall={metadata?.restrictedCitationCount && query.paywallOff !== 'true'} />
      }
      {!metadata?.restrictedCitationCount && pageCount > 1 && (
        <div className={styles.paginatorLayout}>
          <Paginator pageCount={pageCount} currentPage={currentPage} scrollToRef={ref} linkToEnd />
        </div>
      )}
    </div>
  )
}

export default Citations
